import React from "react";
import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-border bg-card/30 mt-16" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="h-8 w-8 rounded-[8px] bg-primary text-primary-foreground flex items-center justify-center font-black">W</div>
            <strong>WiLink</strong>
          </div>
          <p className="text-muted-foreground text-xs leading-relaxed">Le portail interne moderne, léger et sécurisé. Self-hosted, paiement unique, mises à jour à vie.</p>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Produit</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/presentation" className="hover:text-foreground">Présentation</Link></li>
            <li><Link to="/tarifs" className="hover:text-foreground">Tarif</Link></li>
            <li><Link to="/demo" className="hover:text-foreground">Démo</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Société</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
            <li><a href="mailto:info@netkom.fr" className="hover:text-foreground">info@netkom.fr</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Légal</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/mentions-legales" className="hover:text-foreground">Mentions légales</Link></li>
            <li><Link to="/cgv" className="hover:text-foreground">CGV</Link></li>
            <li><Link to="/confidentialite" className="hover:text-foreground">Confidentialité</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs uppercase tracking-[0.2em] text-muted-foreground">
        © {new Date().getFullYear()} WiLink — Tous droits réservés
      </div>
    </footer>
  );
}
